module.exports = __webpack_public_path__ + "media/images/top/ico_bal-e56099c25d21f530c560727de36c3883.png";